/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../controls/controls.module.ts" />
/// <reference path="../../components/common/businessInfo.service.ts" />

module Meevo.Components.Filters {
    'use strict';

    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;

    const MeevoBusinessInfoCheckFilter = (businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService) => {
        if(!BusinessInfoDataService.businessInfoPreferences) {
            businessInfoDataService
                .getBusinessInfoPreferences({force: true});
        }

        const filter: any = (key: string, value: any): boolean => {
            const settings = BusinessInfoDataService.businessInfoPreferences;
            const path: string[] = key.split('.');

            if(!settings) {
                return false;
            }

            let selectedSettings: any = settings[path[0]];
            if (!selectedSettings) {
                return false;
            }


            return selectedSettings[path[1]] == value;
        };

        filter.$stateful = true;

        return filter;
    };

    MeevoBusinessInfoCheckFilter.$inject = ['meevo.components.common.BusinessInfoDataService'];

    angular.module('meevo.components.filters')
        .filter('meevoBusInfoCheck', MeevoBusinessInfoCheckFilter);

}